import filterInvalidRecipients from './filterInvalidRecipients';
import { isSameStringIgnoreCase, isSelf } from './isSelf';
function isSameAddressWrapper(address1, address2) {
    return (address1 == address2 ||
        (address1 &&
            address2 &&
            isSameStringIgnoreCase(address1.EmailAddress, address2.EmailAddress)));
}
function firstIndexOf(array, address) {
    if (array != null && array.length > 0) {
        for (var index = 0; index < array.length; index++) {
            if (isSameAddressWrapper(array[index], address)) {
                return index;
            }
        }
    }
    return -1;
}
function getRecipientsWithoutMyselfAndSender(recipients, sender, exclusions, hasReplyTo) {
    var result = [];
    if (recipients) {
        // Filter when:
        // 1. The email is yourself.
        // 2. The email is the sender AND there's no ReplyTo
        //    (for cases where the via address is in the well explicitly)
        // 3. It's on the exclusions list.
        recipients.forEach(function (recipient) {
            if (!isSelf(recipient) &&
                (hasReplyTo || !isSameAddressWrapper(recipient, sender)) &&
                firstIndexOf(exclusions, recipient) == -1) {
                result.push(recipient);
            }
        });
    }
    return result;
}
function getToRecipients(originalFrom, originalTo, originalCc, originalReplyTo, isReplyAll) {
    var toRecipients;
    var isReplyTo = originalReplyTo && originalReplyTo.length > 0;
    if (isReplyAll) {
        toRecipients = !originalFrom || isSelf(originalFrom) || isReplyTo ? [] : [originalFrom];
        toRecipients = toRecipients.concat(getRecipientsWithoutMyselfAndSender(originalTo, originalFrom, originalReplyTo, isReplyTo));
        if (toRecipients.length == 0 && originalFrom && (!originalCc || originalCc.length == 0)) {
            toRecipients.push(originalFrom);
        }
    }
    else {
        toRecipients = originalFrom ? [originalFrom] : [];
    }
    return toRecipients;
}
function processReplyToHeader(toRecipients, ccRecipients, replyTo, isReplyAll) {
    if (replyTo != null && replyTo.length > 0) {
        if (isReplyAll) {
            // For reply all, the reply-to header recipients are added to To if:
            // 1. it does not already exist in To
            // 2. if it exists in Cc, it goes to To and the corresponding Cc is removed
            replyTo.forEach(function (replyToRecipient) {
                var indexInToRecipients = firstIndexOf(toRecipients, replyToRecipient);
                if (indexInToRecipients == -1) {
                    var indexInCcRecipients = firstIndexOf(ccRecipients, replyToRecipient);
                    if (indexInCcRecipients != -1) {
                        ccRecipients.splice(indexInCcRecipients, 1);
                    }
                    toRecipients.push(replyToRecipient);
                }
            });
        }
        else {
            // For reply, the Reply-To header should replace the To recipient
            toRecipients = replyTo;
        }
    }
    return [toRecipients, ccRecipients];
}
export default function getToCcRecipients(originalFrom, originalTo, originalCc, originalReplyTo, isReplyAll) {
    var toRecipients = getToRecipients(originalFrom, originalTo, originalCc, originalReplyTo, isReplyAll);
    var ccRecipients = isReplyAll
        ? getRecipientsWithoutMyselfAndSender(originalCc, originalFrom, toRecipients /*exclusions*/, originalReplyTo && originalReplyTo.length > 0)
        : [];
    _a = processReplyToHeader(toRecipients, ccRecipients, originalReplyTo, isReplyAll), toRecipients = _a[0], ccRecipients = _a[1];
    // If we end up without a recipient at all, put the excluded original from to the to field if it is present
    if (originalFrom != null && toRecipients.length == 0 && ccRecipients.length == 0) {
        toRecipients.push(originalFrom);
    }
    // At this point, we should filter invalid recipients.
    return [filterInvalidRecipients(toRecipients), filterInvalidRecipients(ccRecipients)];
    var _a;
}
//# sourceMappingURL=getToCcRecipients.js.map